import {TenantStatus} from "app/modules/organization/api/clients.api";

export const TenantStatusNameMap: Map<TenantStatus, string> = new Map<TenantStatus, string>([
    [TenantStatus.Pending, "Pending"],
    [TenantStatus.Created, "Created"],
    [TenantStatus.Deactivated, "Deactivated"],
    [TenantStatus.Live, "Live"],
    [TenantStatus.Suspended, "Suspended"]
]);
